import { Link } from "react-router-dom";

const Register = () => {
  return (
    <>
      <div className="inner-banner before-none bg-white border-top">
        <div className="container">
          <div className="inner-banner-txt">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Register{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="main-section register-pg border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-7 col-xs-12 align-self-center">
              <div className="user-login-box">
                <h1 className="fs-16">Create a account</h1>
                <form method="post" action="#" autoComplete="off">
                  <div className="field">
                    <div className="field-sm">
                      <label>Name</label>
                      <input
                        type="text"
                        name="fname"
                        className="form-control"
                      />
                    </div>
                    <div className="field-sm">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="field-sm">
                      <label>Password</label>
                      <input
                        type="Password"
                        name="password"
                        className="form-control"
                      />
                    </div>
                    <div className="field-sm">
                      <label>Confirm Password</label>
                      <input
                        type="Password"
                        name="confirm-password"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="field-sm">
                      <label>Address Line 1</label>
                      <input
                        type="text"
                        name="address-1"
                        className="form-control"
                      />
                    </div>
                    <div className="field-sm">
                      <label>Address Line 2</label>
                      <input
                        type="text"
                        name="address-2"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="field-sm">
                      <label>City</label>
                      <input type="text" name="city" className="form-control" />
                    </div>
                    <div className="field-sm">
                      <label>Country</label>
                      <select name="country" className="form-control">
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="India">India</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Isle of Man">Isle of Man</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japan">Japan</option>
                        <option value="Jersey">Jersey</option>
                        <option value="Jordan">Jordan</option>
                      </select>
                    </div>
                  </div>
                  <div className="field">
                    <div className="field-sm">
                      <label>Country</label>
                      <select name="country" className="form-control">
                        <option value="">Choose a State/Province</option>
                        <option value="Andaman and Nicobar Islands">
                          Andaman and Nicobar Islands
                        </option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Arunachal Pradesh">
                          Arunachal Pradesh
                        </option>
                        <option value="Assam">Assam</option>
                        <option value="Bihar">Bihar</option>
                        <option value="Chandigarh">Chandigarh</option>
                        <option value="Chhattisgarh">Chhattisgarh</option>
                        <option value="Chhattisgarh">Haryana</option>
                      </select>
                    </div>
                    <div className="field-sm">
                      <label>Zip/Postcode</label>
                      <input
                        type="text"
                        name="zip-code"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <button>
                      {" "}
                      <span className="mbri-login pr-2" /> Create Account{" "}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-5 col-sm-5 col-xs-12">
              <div className="user-message-box border">
                <div className="bg-light">
                  <h2 className="fs-16 wow fadeInUp">New Customer?</h2>
                  <p className="wow fadeInUp">
                    Create an account with us and you'll be able to:
                  </p>
                  <ul className="prd-point">
                    <li>Check out faster</li>
                    <li>Save multiple shipping addresses</li>
                    <li>Access your order history </li>
                    <li>Track new orders </li>
                    <li>Save items to your Wish List</li>
                  </ul>
                  <p>
                    <Link to="/login" className="btn">
                      I have an Account Sign in
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
